import { Injectable } from '@angular/core';
import { AnalyzerMission } from 'src/app/storage/models/analyzer-mission.model';
import { SkidMission } from 'src/app/storage/models/skid-mission.model';
import { Skid } from 'src/app/storage/models/skid.model';
import { AnalyzersService } from './analyzers.service';
import { FlowmetersService } from './flowmeters.service';
import { GatewaysService } from './gateways.service';
import { PumpsService } from './pumps.service';
import { SkidsService } from './skids.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialsService {

  constructor(
    private skidsService: SkidsService,
    private pumpsService: PumpsService,
    private gatewaysService: GatewaysService,
    private flowmetersService: FlowmetersService,
    private analyzersService: AnalyzersService
  ) { }

  setSkidsEquipments(skids: Skid[]): void {
    const pumps = this.pumpsService.pumps$.getValue();
    const gateways = this.gatewaysService.gateways$.getValue();
    const flowmeters = this.flowmetersService.flowmeters$.getValue();

    skids.map(skid => skid.setEquipments({
      pumps: pumps,
      gateways: gateways,
      flowmeters: flowmeters
    }));
  }

  setMissionSkidsEquipments(missionSkids: SkidMission[]): void {
    const skids = this.skidsService.skids$.getValue();
    const pumps = this.pumpsService.pumps$.getValue();
    const gateways = this.gatewaysService.gateways$.getValue();
    const flowmeters = this.flowmetersService.flowmeters$.getValue();

    missionSkids.map(missionSkid => missionSkid.setEquipments({
      skids: skids,
      pumps: pumps,
      gateways: gateways,
      flowmeters: flowmeters
    }));
  }

  setMissionAnalyzersEquipments(missionAnalyzers: AnalyzerMission[]): void {
    const analyzers = this.analyzersService.analyzers$.getValue();
    const gateways = this.gatewaysService.gateways$.getValue();

    missionAnalyzers.map(missionAnalyzer => missionAnalyzer.setEquipments({
      analyzers: analyzers,
      gateways: gateways
    }));
  }

}
